import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { PerformanceContext, PerformanceProvider } from '@/v2/state/providers';
import { StateContext } from '@/v2/state/store';
import query from '@/v2/state/query';
import ScenesHandler from '@/v2/components/application/ScenesHandler';
import Scenes from './__scenes__';
import './Performance.scss';

const onReady = () => {};

const PerformanceComponent = ({ scenes }) => {
    const store = useContext(StateContext);
    const history = useHistory();

    useEffect(() => {
        const { dispatch } = store;
        dispatch({ type: 'ROUTE_LOAD' });
    }, []);

    const onFinished = () => {
        history.push('scenes.html#performance');
    };

    return (
        <div className="Performance">
            {scenes && (
                <ScenesHandler onReady={onReady} onFinished={onFinished} momentName="powerfully">
                    <Scenes.Engine data={scenes[0]} path="engine" />
                    <Scenes.Comfort data={scenes[1]} path="comfort" />
                    <Scenes.Handling data={scenes[2]} path="handling" />
                    <Scenes.HandlingActive data={scenes[3]} path="handlingactive" />
                </ScenesHandler>
            )}
        </div>
    );
};

const PerformanceRenderer = () => {
    const [data, setter] = useContext(PerformanceContext);
    query(window.HELIOS.selectors.powerfully, setter); // TODO: update key once corresponding AEM rename is done
    return <PerformanceComponent scenes={data.scenes} />;
};

const Performance = () => (
    <PerformanceProvider>
        <PerformanceRenderer />
    </PerformanceProvider>
);

export default Performance;
